import {
  CLEAR_FETCH_RSVP_DATE_EM_STATES,
  FETCH_RSVP_DATE_EM_FAILURE,
  FETCH_RSVP_DATE_EM_SUCCESS,
  REQUEST_RSVP_DATE_FETCH_EM,
} from "./rsvpDate.types";

let initialState = {
  relaod: false,
  response: {},
  error: null,
  loading: false,
};

const fetchRSVPDateEmReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_RSVP_DATE_FETCH_EM:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_RSVP_DATE_EM_SUCCESS:
      return {
        ...state,
        loading: false,
        response: action.payload,
        reload: false,
      };

    case FETCH_RSVP_DATE_EM_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        reload: false,
      };

    case CLEAR_FETCH_RSVP_DATE_EM_STATES:
      return {
        ...state,
        loading: false,
        response: {},
        error: null,
        reload: false,
      };

    default:
      return state;
  }
};

export default fetchRSVPDateEmReducer;
